import { CSSProperties, FC } from 'react';

import styles from './Loading.module.scss';

export type MessageLoadingProps = {
    dotsCSSColor?: CSSProperties['backgroundColor'];
};

export const MessageLoading: FC<MessageLoadingProps> = ({ dotsCSSColor }) => {
    const style = !dotsCSSColor ? undefined : ({ '--bg-color': dotsCSSColor } as CSSProperties);

    return (
        <div style={style} className={styles.container}>
            <div className={styles.dot} />
        </div>
    );
};
